import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useApplyDisplayLanguage } from '@src/hooks/language-hooks'
import { useDevTools } from '@src/types/Constants'
import { RouterProvider } from 'react-router-dom'
import MerchantProvider from './MerchantProvider'
import { router } from './router'

// Every app-root provider (i18n, QueryClient, theme, auth gate, feature switches,
// snackbar/dialog/error surfaces) now lives in the single
// GlobalDesignSystemProvider mounted in main.tsx. Below it, MerchantProvider
// boot-loads the current user's merchant so the routed app reads a resolved,
// non-null merchant.
const App = () => {
  useApplyDisplayLanguage()

  return (
    <>
      <MerchantProvider>
        <RouterProvider router={router} />
      </MerchantProvider>
      {useDevTools && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
    </>
  )
}

export default App
